import { render, staticRenderFns } from "./CODVerificationForm.vue?vue&type=template&id=277e9a42&scoped=true"
import script from "./CODVerificationForm.vue?vue&type=script&lang=js"
export * from "./CODVerificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e9a42",
  null
  
)

export default component.exports